import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Kai Faust
 * id CFE631FF-AAD1-49D9-BA22-84BAC90B8787
 * name shape-polygon-plus
 * version: 1.6.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/shape-polygon-plus.svg
 * tags
 * - Shape 
 */
export const ShapePolygonPlusIcon = createSvgIcon(<><path d="M17,15.7V13H19V17L10,21L3,14L7,5H11V7H8.3L5.4,13.6L10.4,18.6L17,15.7M22,5V7H19V10H17V7H14V5H17V2H19V5H22Z" /></>, 'ShapePolygonPlusIcon');
export default ShapePolygonPlusIcon